import { SimpleField } from "../../../../components/fields/simpleField.jsx";
import React from "react";

export function InfoTab({ control }) {
  return (
    <div className={"flex flex-col gap-3 bg-white p-3"}>
      <div className={"flex gap-3"}>
        <div className={"flex-grow"}>
          <SimpleField
            label="First name"
            name={"firstName"}
            control={control}
          />
        </div>
        <div className={"flex-grow"}>
          <SimpleField label="Last name" name={"lastName"} control={control} />
        </div>
      </div>
      <div className={"flex gap-3"}>
        <div className={"flex-grow"}>
          <SimpleField label="Company" name={"company"} control={control} />
        </div>
        <div className={"flex-grow"}>
          <SimpleField label="Website" name={"website"} control={control} />
        </div>
      </div>
      <div className={"flex gap-3"}>
        <div className={"flex-grow"}>
          <SimpleField label="Email" name={"email"} control={control} />
        </div>
        <div className={"flex-grow"}>
          <SimpleField label="Phone" name={"phone"} control={control} />
        </div>
      </div>
      <div className={"flex gap-3"}>
        <div className={"flex-grow"}>
          <SimpleField label="Number" name={"number"} control={control} />
        </div>
        <div className={"flex-grow"}>
          <SimpleField label="Street" name={"street"} control={control} />
        </div>
        <div className={"flex-grow"}>
          <SimpleField label="City" name={"city"} control={control} />
        </div>
      </div>
      <div className={"flex gap-3"}>
        <div className={"flex-grow"}>
          <SimpleField label="Zip" name={"zip"} control={control} />
        </div>
        <div className={"flex-grow"}>
          <SimpleField label="Country" name={"country"} control={control} />
        </div>
      </div>
      <SimpleField label="VAT Number" name={"vatNumber"} control={control} />
    </div>
  );
}
